import script from "./ThemeToggleComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ThemeToggleComponent.vue?vue&type=script&setup=true&lang=js"

import "./ThemeToggleComponent.vue?vue&type=style&index=0&id=00e79f13&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00e79f13"]])

export default __exports__